import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[420px] md:h-[600px] overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Artistic%20stylized%20Korean%20manhwa%20illustration%20with%20warm%20golden%20and%20amber%20tones%2C%20abstract%20comic%20panels%20and%20dynamic%20brush%20strokes%2C%20dramatic%20composition%20with%20flowing%20lines%2C%20digital%20art%20style%2C%20rich%20texture%2C%20no%20text%2C%20cinematic%20atmosphere%2C%20soft%20gradient%20background&width=1600&height=900&seq=hero-bg-hanman-2026&orientation=landscape"
        alt="韩漫大全 - 韩国漫画无删减免费阅读平台"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/40 via-foreground-950/25 to-foreground-950/50"></div>

      <div className="relative z-10 w-full h-full flex items-center">
        <div className="w-full max-w-[1400px] mx-auto px-4 md:px-6">
          <div className="flex flex-col lg:flex-row items-start lg:items-end justify-between h-full pt-20 md:pt-24 pb-12 md:pb-16">
            <div className="flex-1">
              <div className="flex items-center gap-2 mb-6">
                <div className="flex -space-x-3">
                  <div className="w-8 h-8 rounded-full border-2 border-background-50 overflow-hidden">
                    <img src="https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20young%20reader%20avatar%20portrait%2C%20warm%20friendly%20face%2C%20simple%20circle%20style%2C%20clean%20illustration&width=80&height=80&seq=hero-avatar-1&orientation=squarish" alt="用户头像" className="w-full h-full object-cover" />
                  </div>
                  <div className="w-8 h-8 rounded-full border-2 border-background-50 overflow-hidden">
                    <img src="https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20female%20reader%20avatar%20portrait%2C%20warm%20gentle%20face%2C%20simple%20circle%20style%2C%20clean%20illustration&width=80&height=80&seq=hero-avatar-2&orientation=squarish" alt="用户头像" className="w-full h-full object-cover" />
                  </div>
                  <div className="w-8 h-8 rounded-full border-2 border-background-50 overflow-hidden">
                    <img src="https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20male%20reader%20avatar%20portrait%2C%20warm%20friendly%20face%2C%20simple%20circle%20style%2C%20clean%20illustration&width=80&height=80&seq=hero-avatar-3&orientation=squarish" alt="用户头像" className="w-full h-full object-cover" />
                  </div>
                </div>
                <span className="text-background-50/80 text-xs md:text-sm whitespace-nowrap">超过50万韩漫爱好者在此聚集</span>
              </div>

              <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading text-background-50 leading-tight mb-6 max-w-2xl">
                <span className="font-bold">韩国漫画无删减</span>
                <br />
                <span className="font-light">下拉式免费韩漫大全</span>
              </h1>

              <Link
                to="/category/fantasy"
                className="inline-flex items-center gap-2 bg-background-50 text-foreground-900 px-6 py-3 rounded-full text-sm font-medium hover:bg-primary-50 hover:text-primary-600 transition-all duration-300 whitespace-nowrap group"
              >
                开始探索
                <i className="ri-arrow-right-line group-hover:translate-x-1 transition-transform"></i>
              </Link>
            </div>

            <div className="hidden lg:block max-w-sm">
              <p className="text-background-50/80 text-sm leading-relaxed">
                韩漫网站打造无删减韩国漫画下拉式免费韩漫大全平台，资源丰富多元，无广告干扰，让您享受纯净阅读时光。
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}